<template>
	<div>
		<div class="bigBox">
			<div class="leftCont">
				<div class="banner5"></div>
				<div class="picRight">
					<div class="pic-right-box">
						<div class="right-box-title">独立域名</div>
						<div class="right-box-cont">专属独立一级域名部署，面向买家的店铺、商品、微页面域名替换为企业自己的域名。</div>
					</div>
					<img class="pic-right-pic" mode="widthFix" src="../assets/images/def/domain@2x.png" />
				</div>
				<div class="picLeft">
					<img class="pic-right-pic" mode="widthFix" src="../assets/images/def/brand@2x.png" />
					<div class="pic-left-box">
						<div class="left-box-title">系统品牌化，个性化品牌登录</div>
						<div class="left-box-cont">系统根据品牌VI可配置主题色调，通过总部官网登录管理系统，帮助企业提升加盟商及员工的品牌归属感。</div>
					</div>
				</div>
				<div class="picRight">
					<div class="pic-right-box">
						<div class="right-box-title">网店品牌化，全局风格可配置</div>
						<div class="right-box-cont">隐藏底部“摩米贝尔提供技术支持”，全局风格自定义品牌化，加深消费者品牌印象。</div>
					</div>
					<img class="pic-right-pic" mode="widthFix" src="../assets/images/def/domain@2x.png" />
				</div>
				<div class="picLeft">
					<img class="pic-right-pic" mode="widthFix" src="../assets/images/def/brand@2x.png" />
					<div class="pic-left-box">
						<div class="left-box-title">私有App封装</div>
						<div class="left-box-cont">可定制封装老板/员工手机APP端，Android/IOS系统均可选择，嵌套品牌Logo，对顾客展现连锁品牌形象。</div>
					</div>
				</div>
				<div class="picRight">
					<div class="pic-right-box">
						<div class="right-box-title">提供运营指导与培训体系</div>
						<div class="right-box-cont">一对一客户经理服务，助你快速上手并有效提升经营能力，精心筹备“教培资料包”，辅助商家培养自己培训讲师。</div>
					</div>
					<img class="pic-right-pic" mode="widthFix" src="../assets/images/def/domain@2x.png" />
				</div>
				<msg-foot></msg-foot>
			</div>
			<right-cont :activeIndex="activeIndex"></right-cont>
		</div>
	</div>
</template>

<script>
import msgFoot from '../components/msgFoot.vue'
import rightCont from '../components/rightCont.vue'
export default {
	components:{
		msgFoot,
		rightCont
	},
	data(){
		return{
			activeIndex:'5'
		}
	},
	mounted() {
		window.scroll(0, 0); 
	}
}
</script>

<style>
	
	
	
	.right-box-cont{
		text-align: left;
		margin-top: 20px;
		font-size: 14px;
		color: #646566;
		line-height: 20px;
		padding-right: 80px;
	}
	@media screen and (min-width:1200px) {
		.picLeft{
			display: flex;
			padding:80px 40px 24px 40px ;
			background-color: #f9f9f9;
		}
		.picRight{
			padding:80px 40px 24px 40px ;
		}
		.pic-right-pic{
			width: 360px;
		}
		.right-box-title{
			text-align: left;
			font-size: 20px;
			color: #323233;
			line-height: 28px;
			margin-top: 80px;
			font-weight: 500;
		}
		.left-box-title{
			text-align: left;
			font-size: 20px;
			color: #323233;
			line-height: 28px;
			margin-top: 80px;
			font-weight: 500;
			padding-left: 80px;
		}
		.left-box-cont{
			text-align: left;
			margin-top: 20px;
			font-size: 14px;
			color: #646566;
			line-height: 20px;
			padding-left: 80px;
		}
	}
	@media screen and (max-width:1200px) {
		.left-box-title{
			text-align: left;
			font-size: 20px;
			color: #323233;
			line-height: 28px;
			font-weight: 500;
		}
		.left-box-cont{
			text-align: left;
			font-size: 14px;
			color: #646566;
			line-height: 20px;
		}
		.picLeft{
			background-color: #f9f9f9;
			padding: 5vw;
		}
		.picRight{
			padding: 5vw;
		}
		.pic-right-pic{
			width: 100%;
		}
		.right-box-title{
			text-align: left;
			font-size: 20px;
			color: #323233;
			line-height: 28px;
			font-weight: 500;
		}
	}
	
	.pic-right-box{
		flex: 1;
	}
	.pic-left-box{
		flex: 1;
	}
</style>
